t = require('views/internal/teacup-with-helpers')('boards_page_due_soon')

module.exports = t.renderable ({ memberId }) ->

  t.p ->
    t.format 'dont-miss-a-deadline'

  t.p ->
    t.i ->
      t.format 'youre-one-of-the-few-lucky-people'

  t.a { href: 'https://trello.typeform.com/to/LkE077?memberid=' + memberId, target: '_blank' }, ->
    t.format 'let-us-know-what-you-think'

  t.div '.pop-over-section.pop-over-footer', ->
    t.p '.quiet', ->
      t.format 'not-interested'
      t.text ' '
      t.a '.js-disable-due-soon', { href: '#' }, ->
        t.format 'disable-this-feature'



// WEBPACK FOOTER //
// ./app/scripts/views/templates/due_soon_info.coffee